import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Coordinate, Coordinates } from '../models/map';
import { divIcon, icon, marker } from 'leaflet';
import { formatDate } from '@angular/common';
import { ShipmentRouting } from '../../../pages/overview/models/shipment';

@Injectable({
  providedIn: 'root'
})
export class ShipmentMapService {
  private readonly dateFormat = 'yyyy-MM-dd';

  constructor(
    private http: HttpClient,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  getCoordinates(shipmentNumber: string) {
    return this.http.get<Coordinates>(`${environment.apiUrl}/shipments/${shipmentNumber}/geoLocations`);
  }

  originMarker({ latitude, longitude }: Coordinate) {
    return marker([latitude || 0, longitude || 0], {
      icon: divIcon({ className: '', html: `<div class="sgl-timeline__item"></div>` })
    });
  }

  destinationMarker({ latitude, longitude }: Coordinate) {
    return marker([latitude || 0, longitude || 0], {
      icon: icon({
        iconUrl: 'icons/destination_flag.png',
        iconAnchor: [16, 10],
        iconSize: [20, 20]
      })
    });
  }

  originTooltip({ originCode, originName, originEtd }: ShipmentRouting) {
    const date = originEtd ? formatDate(originEtd, this.dateFormat, this.locale, 'UTC') : 'TBA';
    return `<div class="map-tooltip">
              <div class="map-tooltip__header">Origin:</div>
              <div class="map-tooltip__location">${originName} (${originCode})</div>
              <div class="map-tooltip__date">ETD: ${date}</div>
            </div>`;
  }

  destinationTooltip({ destinationName, destinationCode, destinationEta }: ShipmentRouting) {
    const date = destinationEta ? formatDate(destinationEta, this.dateFormat, this.locale, 'UTC') : 'TBA';
    return `<div class="map-tooltip">
              <div class="map-tooltip__header">Destination:</div>
              <div class="map-tooltip__location">${destinationName} (${destinationCode})</div>
              <div class="map-tooltip__date">ETA: ${date}</div>
            </div>`;
  }
}
